/**
 * SidebarHeader
 *
 * Cabeçalho reutilizável para sidebars (título, subtítulo, fechar).
 */

import React from 'react';
import { XIcon } from '../../../components/icons';
import { AppIcon } from '../../../components/icons/AppIcon';
import { cn } from '@/lib/utils';

interface SidebarHeaderProps {
    title: string;
    subtitle?: string;
    onClose: () => void;
    onBack?: () => void;
    hideClose?: boolean;
    /** Header h-16 sem borda — alinha com o chat. */
    compact?: boolean;
    /** id do título (aria-labelledby do dialog) */
    titleId?: string;
}

export const SidebarHeader: React.FC<SidebarHeaderProps> = ({
    title,
    subtitle,
    onClose,
    onBack,
    hideClose = false,
    compact = false,
    titleId = 'sidebar-title',
}) => {
    return (
        <header
            className={cn(
                compact ? 'bg-surface-0' : 'border-b border-border px-s4 py-s4 md:px-s6 md:py-s5',
            )}
        >
            <div
                className={cn(
                    compact
                        ? 'flex h-16 items-center gap-s1 pr-s4'
                        : 'flex items-center justify-between gap-s2',
                )}
            >
                <div className="flex min-w-0 items-center gap-s1">
                    {onBack && (
                        <button
                            type="button"
                            onClick={onBack}
                            className="inline-flex size-11 touch-manipulation items-center justify-center rounded-full text-muted transition-colors hover:bg-primary-subtle hover:text-primary md:size-9"
                            aria-label="Voltar"
                        >
                            <AppIcon name="arrow-left" className="size-5 stroke-[1.5]" aria-hidden />
                        </button>
                    )}
                    <div className="min-w-0">
                        <h2
                            id={titleId}
                            className={cn(compact ? 'chat-label' : 'page-header-title text-default')}
                        >
                            {title}
                        </h2>
                        {subtitle ? (
                            <p className="page-header-subtitle mt-s1 text-muted">{subtitle}</p>
                        ) : null}
                    </div>
                </div>
                {!hideClose && (
                    <button
                        type="button"
                        onClick={onClose}
                        className="inline-flex size-11 touch-manipulation items-center justify-center rounded-lg text-secondary transition-colors hover:bg-surface-subtle hover:text-default md:size-9"
                        aria-label="Fechar"
                    >
                        <XIcon className="size-5" aria-hidden />
                    </button>
                )}
            </div>
        </header>
    );
};

export default SidebarHeader;
